import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { MaterialModule } from 'src/app/material.module';
import { TranslateModule } from '@ngx-translate/core';
import { TablerIconsModule } from 'angular-tabler-icons';
import { MatTableDataSource } from '@angular/material/table';
import { IpdService } from '../../ipd.service';
import { IActiveIPDPatient } from '../iipd-management';
import { debounceTime, distinctUntilChanged, Subject } from 'rxjs';

@Component({
  selector: 'app-ipd-active-list',
  standalone: true,
  imports: [CommonModule, MaterialModule, FormsModule, TranslateModule, TablerIconsModule],
  templateUrl: './ipd-active-list.component.html',
  styleUrls: ['./ipd-active-list.component.scss']
})
export class IpdActiveListComponent implements OnInit {
  displayedColumns = ['ipdNumber', 'patientName', 'wardRoom', 'doctor', 'admissionDate', 'days', 'diagnosis'];
  dataSource = new MatTableDataSource<IActiveIPDPatient>();
  isLoading = false;

  wardFilter: number | null = null;
  doctorFilter: number | null = null;
  searchText = '';

  wardsList: { id: number; name: string }[] = [];
  doctorsList: { id: number; name: string }[] = [];

  searchSubject = new Subject<string>();

  constructor(
    private ipdService: IpdService,
    private router: Router,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.wardsList = this.route.parent?.snapshot.data['ddlward'] || this.route.snapshot.data['ddlward'] || [];
    this.doctorsList = this.route.parent?.snapshot.data['ddlDoctor'] || this.route.snapshot.data['ddlDoctor'] || [];
    this.loadActivePatients();

    this.searchSubject
      .pipe(
        debounceTime(800),
        distinctUntilChanged()
      )
      .subscribe(() => {
        this.loadActivePatients();
      });
  }

  loadActivePatients(): void {
    this.isLoading = true;
    const request = {
      wardId: this.wardFilter,
      doctorId: this.doctorFilter,
      searchText: this.searchText?.trim() || null
    };
    this.ipdService.getActiveIPDPatients(request).subscribe({
      next: (res) => {
        if (res.isSuccess) {
          this.dataSource.data = res.result;
        }
        this.isLoading = false;
      },
      error: (err) => {
        console.error('Failed to load active IPD patients', err);
        this.isLoading = false;
      }
    });
  }

  onSearch(): void {
    this.loadActivePatients();
  }

  onFilterChange(): void {
    this.loadActivePatients();
  }

  clearFilters(): void {
    this.wardFilter = null;
    this.doctorFilter = null;
    this.searchText = '';
    this.loadActivePatients();
  }

  viewPatient(row: IActiveIPDPatient): void {
    this.router.navigate(['/ipd/admit', row.ipdId, 'patient', row.patientId]);
  }

  onSearchChange(value: string): void {
    this.searchText = value;
    this.searchSubject.next(value);
  }

}
